import { ReactNode } from 'react';
import { Redirect } from 'react-router-dom';

import { useLoggedIn } from '~/redux/hooks/useLoggedIn';
import { LOGIN_REQUIRED_PATH } from '~/routes/paths';

function EnsureLoggedInContainer({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const isLoggedIn = useLoggedIn();

  if (!isLoggedIn) {
    return <Redirect to={LOGIN_REQUIRED_PATH} />;
  }

  return <>{children}</>;
}

export default EnsureLoggedInContainer;
